import { Outlet } from 'react-router';
import { TestModeProvider } from '../context/TestModeContext';

export function TestModeLayout() {
  return (
    <TestModeProvider>
      <Outlet />
    </TestModeProvider>
  );
}
